// extracted by mini-css-extract-plugin
module.exports = {"button":"Quantity_button__ve3uw","input":"Quantity_input__PXMrC","quantity":"Quantity_quantity__Uz2Bf"};